

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as UtilityTypes from '../utilities/types'

import * as SettlementTypes from "./types"

export type SettlementInstrumentGetAllKey = ['companies',string | undefined,'investors',string | undefined,'settlement-instruments',unknown];

export type SettlementInstrumentGetAllResponse = UtilityTypes.Paging & {
    count: number;
    data: Array<SettlementTypes.SettlementInstrument>;
};

export type SettlementInstrumentGetAllVariables = {
    companyId: string | undefined;
    investorId: string | undefined;
    body?: void;
    query?: void;
}

export const settlementInstrumentGetAll = makeData<
  SettlementInstrumentGetAllResponse,
  SettlementInstrumentGetAllKey,
  SettlementInstrumentGetAllVariables
>({
  method: 'get',
  name: 'settlementInstrumentGetAll',
  summary: "Get settlement instruments",
  path: '/companies/{companyId}/investors/{investorId}/settlement-instruments',
  queryKey: ({query, companyId,
investorId,}) => ['companies',companyId,'investors',investorId,'settlement-instruments', query],
})

export type SettlementInstrumentCreateKey = ['companies',string | undefined,'investors',string | undefined,'settlement-instruments',unknown];

export type SettlementInstrumentCreateResponse = UtilityTypes.SingletonResponse & {
    data?: SettlementTypes.SettlementInstrument;
};

export type SettlementInstrumentCreateVariables = {
    companyId: string | undefined;
    investorId: string | undefined;
    body?: SettlementTypes.SettlementInstrument;
    query?: void;
}

export const settlementInstrumentCreate = makeData<
  SettlementInstrumentCreateResponse,
  SettlementInstrumentCreateKey,
  SettlementInstrumentCreateVariables
>({
  method: 'post',
  name: 'settlementInstrumentCreate',
  summary: "Create settlement instrument",
  path: '/companies/{companyId}/investors/{investorId}/settlement-instruments',
  queryKey: ({query, companyId,
investorId,}) => ['companies',companyId,'investors',investorId,'settlement-instruments', query],
})

export type SettlementInstrumentGetKey = ['companies',string | undefined,'investors',string | undefined,'settlement-instruments',string | undefined,unknown];

export type SettlementInstrumentGetResponse = UtilityTypes.SingletonResponse & {
    data?: SettlementTypes.SettlementInstrument;
};

export type SettlementInstrumentGetVariables = {
    companyId: string | undefined;
    investorId: string | undefined;
    settlementInstrumentId: string | undefined;
    body?: void;
    query?: void;
}

export const settlementInstrumentGet = makeData<
  SettlementInstrumentGetResponse,
  SettlementInstrumentGetKey,
  SettlementInstrumentGetVariables
>({
  method: 'get',
  name: 'settlementInstrumentGet',
  summary: "Get settlement instrument by ID",
  path: '/companies/{companyId}/investors/{investorId}/settlement-instruments/{settlementInstrumentId}',
  queryKey: ({query, companyId,
investorId,
settlementInstrumentId,}) => ['companies',companyId,'investors',investorId,'settlement-instruments',settlementInstrumentId, query],
})

export type SettlementInstrumentUpdateKey = ['companies',string | undefined,'investors',string | undefined,'settlement-instruments',string | undefined,unknown];

export type SettlementInstrumentUpdateResponse = void;

export type SettlementInstrumentUpdateVariables = {
    companyId: string | undefined;
    investorId: string | undefined;
    settlementInstrumentId: string | undefined;
    body?: SettlementTypes.SettlementInstrumentMutable;
    query?: void;
}

export const settlementInstrumentUpdate = makeData<
  SettlementInstrumentUpdateResponse,
  SettlementInstrumentUpdateKey,
  SettlementInstrumentUpdateVariables
>({
  method: 'put',
  name: 'settlementInstrumentUpdate',
  summary: "Update settlement instrument",
  path: '/companies/{companyId}/investors/{investorId}/settlement-instruments/{settlementInstrumentId}',
  queryKey: ({query, companyId,
investorId,
settlementInstrumentId,}) => ['companies',companyId,'investors',investorId,'settlement-instruments',settlementInstrumentId, query],
})

export type FundingInstrumentGetAllKey = ['companies',string | undefined,'payment-processors',string | undefined,'funding-instruments',unknown];

export type FundingInstrumentGetAllResponse = UtilityTypes.Paging & {
    count: number;
    data: Array<SettlementTypes.FundingInstrument>;
};

export type FundingInstrumentGetAllVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
    };
}

export const fundingInstrumentGetAll = makeData<
  FundingInstrumentGetAllResponse,
  FundingInstrumentGetAllKey,
  FundingInstrumentGetAllVariables
>({
  method: 'get',
  name: 'fundingInstrumentGetAll',
  summary: "Get funding instruments",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/funding-instruments',
  queryKey: ({query, companyId,
paymentProcessorId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'funding-instruments', query],
})

export type FundingInstrumentCreateKey = ['companies',string | undefined,'payment-processors',string | undefined,'funding-instruments',unknown];

export type FundingInstrumentCreateResponse = UtilityTypes.SingletonResponse & {
    data?: SettlementTypes.FundingInstrument;
};

export type FundingInstrumentCreateVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    body?: SettlementTypes.FundingInstrument;
    query?: void;
}

export const fundingInstrumentCreate = makeData<
  FundingInstrumentCreateResponse,
  FundingInstrumentCreateKey,
  FundingInstrumentCreateVariables
>({
  method: 'post',
  name: 'fundingInstrumentCreate',
  summary: "Create funding instrument",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/funding-instruments',
  queryKey: ({query, companyId,
paymentProcessorId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'funding-instruments', query],
})

export type FundingInstrumentGetKey = ['companies',string | undefined,'payment-processors',string | undefined,'funding-instruments',string | undefined,unknown];

export type FundingInstrumentGetResponse = UtilityTypes.SingletonResponse & {
    data?: SettlementTypes.FundingInstrument;
};

export type FundingInstrumentGetVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    fundingInstrumentId: string | undefined;
    body?: void;
    query?: void;
}

export const fundingInstrumentGet = makeData<
  FundingInstrumentGetResponse,
  FundingInstrumentGetKey,
  FundingInstrumentGetVariables
>({
  method: 'get',
  name: 'fundingInstrumentGet',
  summary: "Get funding instrument by ID",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/funding-instruments/{fundingInstrumentId}',
  queryKey: ({query, companyId,
paymentProcessorId,
fundingInstrumentId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'funding-instruments',fundingInstrumentId, query],
})

export type FundingInstrumentUpdateKey = ['companies',string | undefined,'payment-processors',string | undefined,'funding-instruments',string | undefined,unknown];

export type FundingInstrumentUpdateResponse = void;

export type FundingInstrumentUpdateVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    fundingInstrumentId: string | undefined;
    body?: SettlementTypes.FundingInstrumentMutable;
    query?: void;
}

export const fundingInstrumentUpdate = makeData<
  FundingInstrumentUpdateResponse,
  FundingInstrumentUpdateKey,
  FundingInstrumentUpdateVariables
>({
  method: 'put',
  name: 'fundingInstrumentUpdate',
  summary: "Update funding instrument",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/funding-instruments/{fundingInstrumentId}',
  queryKey: ({query, companyId,
paymentProcessorId,
fundingInstrumentId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'funding-instruments',fundingInstrumentId, query],
})

export type GetRecentFundingAccountBalancesKey = ['companies',string | undefined,'payment-processors',string | undefined,'funding-instruments',string | undefined,'balance',unknown];

export type GetRecentFundingAccountBalancesResponse = UtilityTypes.NewPaginator & {
    data?: Array<SettlementTypes.FundingAccountBalance>;
};

export type GetRecentFundingAccountBalancesVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    fundingInstrumentId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
    };
}

export const getRecentFundingAccountBalances = makeData<
  GetRecentFundingAccountBalancesResponse,
  GetRecentFundingAccountBalancesKey,
  GetRecentFundingAccountBalancesVariables
>({
  method: 'get',
  name: 'getRecentFundingAccountBalances',
  summary: "Fetch balances for the funding instrument",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/funding-instruments/{fundingInstrumentId}/balance',
  queryKey: ({query, companyId,
paymentProcessorId,
fundingInstrumentId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'funding-instruments',fundingInstrumentId,'balance', query],
})

export type FundingInstrumentCreateBalanceKey = ['companies',string | undefined,'payment-processors',string | undefined,'funding-instruments',string | undefined,'balance',unknown];

export type FundingInstrumentCreateBalanceResponse = UtilityTypes.SingletonResponse & {
    data?: SettlementTypes.FundingAccountBalance;
};

export type FundingInstrumentCreateBalanceVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    fundingInstrumentId: string | undefined;
    body?: SettlementTypes.FundingAccountBalance;
    query?: void;
}

export const fundingInstrumentCreateBalance = makeData<
  FundingInstrumentCreateBalanceResponse,
  FundingInstrumentCreateBalanceKey,
  FundingInstrumentCreateBalanceVariables
>({
  method: 'post',
  name: 'fundingInstrumentCreateBalance',
  summary: "Add a new balance to the funding instrument",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/funding-instruments/{fundingInstrumentId}/balance',
  queryKey: ({query, companyId,
paymentProcessorId,
fundingInstrumentId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'funding-instruments',fundingInstrumentId,'balance', query],
})

export type GetAllTransferSettlementsForAllCompaniesKey = ['settlements',unknown];

export type GetAllTransferSettlementsForAllCompaniesResponse = UtilityTypes.NewPaginator & {
    data?: Array<SettlementTypes.TransferSettlement>;
};

export type GetAllTransferSettlementsForAllCompaniesVariables = {
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
        statuses?: Array<("readyForFunding" | "funded" | "processing" | "failedFunding")>;
    };
}

export const getAllTransferSettlementsForAllCompanies = makeData<
  GetAllTransferSettlementsForAllCompaniesResponse,
  GetAllTransferSettlementsForAllCompaniesKey,
  GetAllTransferSettlementsForAllCompaniesVariables
>({
  method: 'get',
  name: 'getAllTransferSettlementsForAllCompanies',
  summary: "Get all the transfer settlements for all companies",
  path: '/settlements',
  queryKey: ({query, }) => ['settlements', query],
})

export type GetAllTransferSettlementsForProcessorKey = ['payment-processors',string | undefined,'settlements',unknown];

export type GetAllTransferSettlementsForProcessorResponse = UtilityTypes.NewPaginator & {
    data?: Array<SettlementTypes.TransferSettlement>;
};

export type GetAllTransferSettlementsForProcessorVariables = {
    paymentProcessorId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
        statuses?: Array<("readyForFunding" | "funded" | "processing" | "failedFunding")>;
    };
}

export const getAllTransferSettlementsForProcessor = makeData<
  GetAllTransferSettlementsForProcessorResponse,
  GetAllTransferSettlementsForProcessorKey,
  GetAllTransferSettlementsForProcessorVariables
>({
  method: 'get',
  name: 'getAllTransferSettlementsForProcessor',
  summary: "Get all transfer settlements for a payment processor across all companies",
  path: '/payment-processors/{paymentProcessorId}/settlements',
  queryKey: ({query, paymentProcessorId,}) => ['payment-processors',paymentProcessorId,'settlements', query],
})

export type GetAllTransferSettlementsKey = ['companies',string | undefined,'settlements',unknown];

export type GetAllTransferSettlementsResponse = {
    count?: number;
    total?: number;
    data?: Array<SettlementTypes.TransferSettlement>;
}

export type GetAllTransferSettlementsVariables = {
    companyId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
        statuses?: Array<("readyForFunding" | "funded" | "processing" | "failedFunding")>;
    };
}

export const getAllTransferSettlements = makeData<
  GetAllTransferSettlementsResponse,
  GetAllTransferSettlementsKey,
  GetAllTransferSettlementsVariables
>({
  method: 'get',
  name: 'getAllTransferSettlements',
  summary: "Get all the transfer settlements",
  path: '/companies/{companyId}/settlements',
  queryKey: ({query, companyId,}) => ['companies',companyId,'settlements', query],
})

export type CreateTransferSettlementsKey = ['companies',string | undefined,'settlements',unknown];

export type CreateTransferSettlementsResponse = {
    data?: Array<SettlementTypes.TransferSettlement>;
}

export type CreateTransferSettlementsVariables = {
    companyId: string | undefined;
    body?: void;
    query?: void;
}

export const createTransferSettlements = makeData<
  CreateTransferSettlementsResponse,
  CreateTransferSettlementsKey,
  CreateTransferSettlementsVariables
>({
  method: 'post',
  name: 'createTransferSettlements',
  summary: "Create a new transfer settlement",
  path: '/companies/{companyId}/settlements',
  queryKey: ({query, companyId,}) => ['companies',companyId,'settlements', query],
})

export type GetCompanyTransferSettlementsForProcessorKey = ['companies',string | undefined,'payment-processors',string | undefined,'settlements',unknown];

export type GetCompanyTransferSettlementsForProcessorResponse = {
    count?: number;
    total?: number;
    data?: Array<SettlementTypes.TransferSettlement>;
}

export type GetCompanyTransferSettlementsForProcessorVariables = {
    companyId: string | undefined;
    paymentProcessorId: string | undefined;
    body?: void;
    query?: {
        /**
         * @default
         *     25
         */
        limit?: number;
        startingAfter?: string;
        endingBefore?: string;
        statuses?: Array<("readyForFunding" | "funded" | "processing" | "failedFunding")>;
    };
}

export const getCompanyTransferSettlementsForProcessor = makeData<
  GetCompanyTransferSettlementsForProcessorResponse,
  GetCompanyTransferSettlementsForProcessorKey,
  GetCompanyTransferSettlementsForProcessorVariables
>({
  method: 'get',
  name: 'getCompanyTransferSettlementsForProcessor',
  summary: "Get transfer settlements for a company scoped to a payment processor",
  path: '/companies/{companyId}/payment-processors/{paymentProcessorId}/settlements',
  queryKey: ({query, companyId,
paymentProcessorId,}) => ['companies',companyId,'payment-processors',paymentProcessorId,'settlements', query],
})

export type GetTransferSettlementKey = ['companies',string | undefined,'settlements',string | undefined,unknown];

export type GetTransferSettlementResponse = UtilityTypes.SingletonResponse & SettlementTypes.TransferSettlement;

export type GetTransferSettlementVariables = {
    companyId: string | undefined;
    transferSettlementId: string | undefined;
    body?: void;
    query?: void;
}

export const getTransferSettlement = makeData<
  GetTransferSettlementResponse,
  GetTransferSettlementKey,
  GetTransferSettlementVariables
>({
  method: 'get',
  name: 'getTransferSettlement',
  summary: "Get a transfer settlement by ID",
  path: '/companies/{companyId}/settlements/{transferSettlementId}',
  queryKey: ({query, companyId,
transferSettlementId,}) => ['companies',companyId,'settlements',transferSettlementId, query],
})

export type UpdateTransferSettlementKey = ['companies',string | undefined,'settlements',string | undefined,unknown];

export type UpdateTransferSettlementResponse = void;

export type UpdateTransferSettlementVariables = {
    companyId: string | undefined;
    transferSettlementId: string | undefined;
    body?: {
        /** Update settlement status. */
        status?: "readyForFunding" | "funded";
        /** Settlement gross amount. */
        grossAmount?: number;
        /** Settlement net amount. */
        netAmount?: number;
        /** When true, this settlement bypassed regardless of the minimum investor settlement amount threshold. */
        isTesting?: boolean;
    };
    query?: void;
}

export const updateTransferSettlement = makeData<
  UpdateTransferSettlementResponse,
  UpdateTransferSettlementKey,
  UpdateTransferSettlementVariables
>({
  method: 'put',
  name: 'updateTransferSettlement',
  summary: "Update a transfer settlement by ID",
  path: '/companies/{companyId}/settlements/{transferSettlementId}',
  queryKey: ({query, companyId,
transferSettlementId,}) => ['companies',companyId,'settlements',transferSettlementId, query],
})

export type UpdateTransfersExpectingFundingKey = ['companies',string | undefined,'transfers',unknown];

export type UpdateTransfersExpectingFundingResponse = void;

export type UpdateTransfersExpectingFundingVariables = {
    companyId: string | undefined;
    body?: void;
    query?: void;
}

export const updateTransfersExpectingFunding = makeData<
  UpdateTransfersExpectingFundingResponse,
  UpdateTransfersExpectingFundingKey,
  UpdateTransfersExpectingFundingVariables
>({
  method: 'put',
  name: 'updateTransfersExpectingFunding',
  summary: "Update the transfers expecting funding",
  path: '/companies/{companyId}/transfers',
  queryKey: ({query, companyId,}) => ['companies',companyId,'transfers', query],
})
